import { render, staticRenderFns } from "./deleteMaintainanceStandard.vue?vue&type=template&id=0edf0326"
import script from "./deleteMaintainanceStandard.vue?vue&type=script&lang=js"
export * from "./deleteMaintainanceStandard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports